<template>
    <apex-chart type="line" :height="300" :options="chartOptions" :series="seriesData" />
</template>
<script>
export default {
    props: ['series', 'title', 'unit', 'type'],
    computed: {
        seriesData() {
            return this.series.map(item => ({
                name: item.name,
                data: item.data.map(data => data.value ?? 0)
            }));
        },
        chartOptions() {
            return {
                chart: {
                    id: this.title,
                    toolbar: {
                        tools: {
                            selection: false,
                            zoom: false,
                            zoomin: false,
                            zoomout: false,
                            reset: false,
                            pan: false
                        }
                    }
                },
                title: {
                    text: this.title
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'smooth',
                    width: 2
                },
                tooltip: {
                    y: {
                        title: {
                            formatter: seriesName => `${this.title}:`
                        },
                        formatter: value => {
                            if (value === 0) return `0${this.unit}`;
                            if (Math.abs(value) < 0.1) return `${value?.toFixed(2)} ${this.unit}`;
                            if (Math.abs(value) < 1) return `${value.toFixed(1)} ${this.unit}`;
                            return `${value.toFixed(0)} ${this.unit}`;
                        }
                    },
                    x: {
                        formatter: seriesName => this.getTooltipX(seriesName)
                    }
                },
                yaxis: {
                    labels: {
                        formatter: value => {
                            if (value === 0) return 0;
                            if (Math.abs(value) < 0.1) return value.toFixed(2);
                            if (Math.abs(value) < 1) return value.toFixed(1);
                            return value.toFixed(0);
                        }
                    }
                },
                xaxis: {
                    categories:
                        this.series.length > 0 ? this.series[0].data.map(item => item.label) : [],
                    labels: {
                        rotate: 0,
                        hideOverlappingLabels: true
                    }
                }
            };
        }
    },
    methods: {
        getTooltipX(value) {
            if (this.type === 'byHour') return `${value} giờ`;
            if (this.type === 'byDay') {
                if (value === 'CN') return 'Chủ nhật';
                return value.toString().replace('T', 'Thứ ');
            }
            return `Ngày ${value}`;
        }
    }
};
</script>
